import React, { useState } from "react";
import apiClient from "./apiClient";
import { X, MessageSquare } from "lucide-react";
import {useLocation} from 'react-router-dom';

export const InquiryForm = () => {
  const [formData, setFormData] = useState({ name: "", workType: "", contact: "" });
  const [showForm, setShowForm] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const location = useLocation();

  if (location.pathname.includes("article-details")) {
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const whatsappMessage = `Hello! Preview Tax, I am ${formData.name}. I need help with ${formData.workType}. My contact number is ${formData.contact}.`;
    const whatsappURL = `https://api.whatsapp.com/send?phone=919315265493&text=${encodeURIComponent(whatsappMessage)}`;

    try {
      await apiClient
        .post("/users", {
          name: formData.name,
          contact_no: formData.contact,
          service_type: formData.workType,
      });

      setShowForm(false);
      setFormData({ name: "", workType: "", contact: "" });
      setSuccessMessage(true);
      setTimeout(() => {
          setSuccessMessage(false);
          window.open(whatsappURL, "_blank");
        }, 2000);
      } catch (error) {
        alert("Failed to submit inquiry. Please try again.");
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowForm(!showForm)}
        className="fixed bottom-5 right-5 z-40 transform bg-orange-500 text-white rounded-full p-4 shadow-lg hover:scale-110 transition-transform"
        aria-label="Open inquiry form"
      >
        <MessageSquare className="w-6 h-6" aria-hidden="true" />
      </button>

      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
          <div className="bg-white rounded-lg shadow-2xl border-2 border-orange-500 shadow-2xl w-full max-w-md p-8 relative relative animate__animated animate__fadeInDown">
            <button
              onClick={() => setShowForm(false)}
              aria-label="Close inquiry form"
              className="absolute top-4 right-4 text-2xl text-orange-500 font-bold cursor-pointer hover:text-orange-700"
            >
              <X className="w-5 h-5 text-gray-600" />
            </button>
            <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
              <h3 className="text-2xl text-center font-bold text-orange-700 mb-6 font-serif">Inquiry Form</h3>
              <input
                type="text"
                placeholder="Name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-orange-300"
                required
              />
              <select
                value={formData.workType}
                onChange={(e) => setFormData({ ...formData, workType: e.target.value })}
                className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-orange-300"
                required
              >
                <option value="">Select Type of Work</option>
                <option value="E-Commerce">E-Commerce</option>
                <option value="Website Service">Website Services</option>
                <option value="Tax and Compliance">Tax and Compliance</option>
                <option value="Registrations">Registrations</option>
                <option value="Import-Export">Import-Export</option>
                <option value="Virtual CFO Services">Virtual CFO Services</option>
              </select>
              <div className="flex flex-row gap-2">
                <input type="text" value="+91" disabled className="p-3 w-16 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-orange-300"/>
                <input
                  type="text"
                  placeholder="Contact Number"
                  value={formData.contact}
                  onChange={(e) => setFormData({ ...formData, contact: e.target.value })}
                  className="p-3 flex-1 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-orange-300"
                  required
                />
              </div>
              <button
                type="submit"
                className="p-3 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition-colors"
              >
                Get a Personalized Plan 
              </button>
            </form>
          </div>
        </div>
      )}

      {successMessage && (
        <div className="fixed bottom-10 right-10 bg-green-500 text-white p-4 rounded shadow-lg z-50">
          Form data has been submitted successfully!
        </div>
      )}
    </div>
  );
};
